// Contacts GraphQL queries

import { gql } from "@apollo/client"

export const GET_CONTACTS = gql`
  query GetContacts($fresh: Boolean) {
    getContacts(fresh: $fresh) {
      id
      contactID
      firstName
      lastName
      displayName
      email
      companyName
      title
      jobTitle
      gender
      phone1
      phone2
      phone3
      active
      businessAccount
    }
  }
`

export const GET_CONTACT_BY_ID = gql`
  query GetContactById($contactID: String!, $fresh: Boolean) {
    getContactById(contactID: $contactID, fresh: $fresh) {
      id
      contactID
      firstName
      lastName
      title
      displayName
      email
      companyName
      gender
      phone1
      phone2
      phone3
      active
      businessAccount
    }
  }
`
